import React from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

const Contact = () => {
    const [name, setName] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [message, setMessage] = React.useState('')
    const [show, setShow] = React.useState(false);
    const [show2, setShow2] = React.useState(false);
    const [show4, setShow4] = React.useState(false);


    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const validate = () => {
        if (name === '' || email === '' || message === '') {
            notify('Please fill all the fields')
            return false
        }
        if (!name.match(/^[a-zA-Z ]+$/)) {
            notify('Name must contain only letters')
            return false
        }
        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
            notify('Please enter a valid email')
            return false
        }
        return true
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (validate()) {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ name, email: email.toLowerCase(), message })
            }
            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/contact/addFeedback', config)
            const data = await response.json()
            notify(data.message)
        }
    }


    return (
        <div className='dark:text-white dark:bg-black bg-[#F8FBF8]'>
            <Navbar />
            <section className="text-gray-600 body-font relative">
                <div className=" lg:mx-32 px-5 py-24 flex sm:flex-nowrap flex-wrap">
                    <div className="lg:w-2/3 md:w-1/2  dark:grayscale bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
                        <iframe width="100%" height="100%" className="absolute inset-0" frameBorder="0" title="map" marginHeight="0" marginWidth="0" scrolling="no" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.1250000000005!2d77.20999999999998!3d28.629999999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf8f5b8b9b8d7%3A0x3e7b3e2b2b2b2b2b!2sGo%20Green%20Nursery!5e0!3m2!1sen!2sin!4v1625581000000!5m2!1sen!2sin" style={{ filter: "grayscale(1) contrast(1.2) opacity(0.4)" }}
                        ></iframe>
                        <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md">
                            <div className="lg:w-1/2 px-6">
                                <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">ADDRESS</h2>
                                <p className="mt-1">XYZ, ABC DERTYUIO, Delhi - 110055</p>
                            </div>
                            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
                                <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">EMAIL</h2>
                                <a className="text-green-500 leading-relaxed" href="/">go.green.nursery@outlook.com</a>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/3 md:w-1/2  flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
                        <h2 className="text-gray-900 dark:text-white text-lg mb-1 font-medium title-font">Feedback</h2>
                        <p className="leading-relaxed mb-5 dark:text-gray-500 text-gray-600">We would like your feedback to improve our website.</p>
                        <p className="leading-relaxed mb-5 dark:text-gray-500 text-gray-600">What is your opinion of this page.</p>

                        <div className="relative mb-4">
                            <label htmlFor="name" className="leading-7 text-sm dark:text-white text-gray-600">Name</label>
                            <input type="text" id="name" name="name" className="w-full bg-white rounded border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" onChange={e => setName(e.target.value)} />
                        </div>
                        <div className="relative mb-4">
                            <label htmlFor="email" className="leading-7 text-sm dark:text-white text-gray-600">Email</label>
                            <input type="email" id="email" name="email" className="w-full bg-white rounded border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className="relative mb-4">
                            <label htmlFor="message" className="leading-7 text-sm dark:text-white text-gray-600">Message</label>
                            <textarea id="message" name="message" className="w-full bg-white rounded border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out" onChange={e => setMessage(e.target.value)} ></textarea>
                        </div>
                        <button onClick={handleSubmit} className="text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">Submit</button>
                        <p className="text-xs text-gray-500 mt-3">Please leave your valuable feedback above. We will try our best to provide a better service.
                        </p>
                    </div>
                </div>
            </section>
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className=" 2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4">
                <h2 className=" font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 dark:text-white text-gray-800">Frequently Asked Questions</h2>
                <div className="mt-4 flex md:justify-between md:items-start md:flex-row flex-col justify-start items-start">
                    <div className=" ">
                        <p className=" font-normal text-base leading-6 dark:text-gray-500 text-gray-600 lg:w-8/12 md:w-9/12 ">Here are few of the most frequently asked questions by our valuable customers</p>
                    </div>


                </div>
                <div className=" flex md:flex-row flex-col md:space-x-8 md:mt-16 mt-8">
                    <div className=" md:w-5/12 lg:w-4/12 w-full ">
                        <img src="https://www.chatelaine.com/wp-content/uploads/2016/05/Hanging-planters.jpg" alt="DummyImage" className="w-full md:block hidden" />
                    </div>
                    <div className=" md:w-7/12 lg:w-8/12 w-full md:mt-0 sm:mt-14 mt-10">
                        {/* <!-- Shipping Section --> */}
                        <div>
                            <div>
                                <div className=" flex justify-between items-center cursor-pointer">
                                    <h3 className=" font-semibold  dark:text-white text-xl leading-5 text-gray-800">Shipping</h3>
                                    <button aria-label="too" className=" dark:text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" onClick={() => setShow(!show)}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path className={show ? "hidden" : "block"} d="M10 4.1665V15.8332" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M4.16602 10H15.8327" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                                <p className={"font-normal text-base leading-6 dark:text-gray-500 text-gray-600 mt-4 w-11/12 " + (show ? "block" : "hidden")}><b>When will I receive my order?</b><br></br>

                                    Generally, your order will be dispatched within 5 to 7 working days after your transaction has been confirmed. However, depending on the product the dispatch time may vary. Please refer to your product description for more details. You will also be notified via email when the product(s) are shipped to you.</p>
                            </div>
                        </div>

                        <hr className=" my-7 bg-gray-200" />

                        {/* <!-- Returns Section --> */}

                        <div>
                            <div className=" flex justify-between items-center cursor-pointer">
                                <h3 className=" font-semibold text-xl leading-5 dark:text-white text-gray-800">Returns</h3>
                                <button aria-label="too" className=" cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" onClick={() => setShow2(!show2)}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={show2 ? "hidden" : "block"} d="M10 4.1665V15.8332" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.16602 10H15.8327" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                            <p className={"font-normal text-base leading-6 dark:text-gray-500 text-gray-600 mt-4 w-11/12 " + (show2 ? "block" : "hidden")}><b>Refund Policy</b>
                                <br></br>
                                Orders delivered & accepted by the customer cannot be refunded.

                                In case you feel the order is not as per specification, please contact our customer care team immediately in 24hrs.<br></br>
                                <Link to="/return">Click here</Link> to check our Return Policy
                            </p>
                        </div>

                        <hr className=" my-7 bg-gray-200" />

                        {/* <!-- Exchange Section --> */}
                        {/* 
                        <div>
                            <div className=" flex justify-between items-center cursor-pointer">
                                <h3 className=" font-semibold text-xl leading-5 dark:text-white text-gray-800">Exchange</h3>
                                <button aria-label="too" className=" cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" onClick={() => setShow3(!show3)}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={show3 ? "hidden" : "block"} d="M10 4.1665V15.8332" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.16602 10H15.8327" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                            <p className={"font-normal text-base leading-6 dark:text-gray-500 text-gray-600 mt-4 w-11/12 " + (show3 ? "block" : "hidden")}>We are covering every major country worldwide. The shipment leaves from US as it is our headquarter. Some extra information you probably need to add here so that the customer is clear of their wanted expectations.</p>
                        </div>

                        <hr className=" my-7 bg-gray-200" /> */}

                        {/* Tracking Section */}

                        <div>
                            <div className=" flex justify-between items-center cursor-pointer">
                                <h3 className=" font-semibold text-xl leading-5 dark:text-white text-gray-800">Tracking</h3>
                                <button aria-label="too" className=" cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800" onClick={() => setShow4(!show4)}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={show4 ? "hidden" : "block"} d="M10 4.1665V15.8332" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.16602 10H15.8327" stroke="#1F2937" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                            <p className={"font-normal text-base leading-6 dark:text-gray-500 text-gray-600 mt-4 w-11/12 " + (show4 ? "blcok" : "hidden")}>blank </p>
                        </div>

                        <hr className=" my-7 bg-gray-200" />
                    </div>
                </div>
            </div>
            <SmallFooter />
        </div>
    )
}

export default Contact